import { Typography, Box, InputLabel, Link } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { AuthenticationContext } from "../../Context";
import { useFlash } from "../../FlashContext";
import GeneralModal from "../../modals/GeneralModal";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateToString, formatToUsDateFromUTCNew } from "../../utils/DateHelper";
import { isValid } from "date-fns";
import { isSameDay } from "date-fns";
import { getHeaders } from "../../utils/HeaderHelper";

const DueDateModal = ({
  open,
  onCloseModal,
  actionQueueId,
  dueDate,
  reloadData,
}) => {
  const [selectedDueDate, setSelectedDueDate] = React.useState<string>(
    dueDate || ""
  );

  const handleCloseModal = () => {
    onCloseModal();
  };

  const [showDatePicker, setShowDatePicker] = useState(false);
  const handleDateChange = (date) => {
    if (date instanceof Date && isValid(date)) {
      setSelectedDueDate(dateToString(date));
      setShowDatePicker(false);
    }
  };
  const renderDay = (day, selectedDate, isInCurrentMonth, dayComponent) => {
    const today = new Date();
    const isToday = isSameDay(day, today) && !isSameDay(selectedDate, today);

    return React.cloneElement(dayComponent, {
      style: {
        color: isToday ? "#ff890a" : undefined,
      },
    });
  };

  const authenticationSetting = React.useContext(AuthenticationContext);
  const { showToast } = useFlash();

  const handleSuccessCallback = async () => {
    try {
      const response = await fetch(
        `/action_queues/${actionQueueId}/update_due_date`,
        {
          method: "PUT",
          headers: getHeaders(authenticationSetting.csrfToken),
          body: JSON.stringify({
            due_date: new Date(selectedDueDate),
          }),
        }
      );
      const result = await response.json();
      showToast({
        title: result.success == false ? "Error" : "Success",
        text: result.message,
        type: result.success == false ? "error" : "success",
      });
      reloadData();
      onCloseModal();
    } catch (error) {
      showToast({
        title: "Error",
        text: "Something went wrong.",
        type: "error",
      });
      reloadData();
    }
  };

  return (
    <GeneralModal
      open={open}
      title={`Change Due Date`}
      successCallback={handleSuccessCallback}
      closeCallback={handleCloseModal}
      showCancelButton={true}
      showContinueIcon={true}
      fullWidth={true}
      confirmButtonText="Update Action"
      width="430px"
      confirmButtonClass="modal-update-due-date-btn"
    >
      <Box
        sx={{
          padding: "0px 24px",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: "22px",
            color: "#1E1E1E",
          }}
        >
          Adjust the due date for this action. Changing the due date will update
          the action’s recurrence.
        </Typography>
        <Box
          sx={{
            marginTop: "24px",
          }}
        >
          <InputLabel
            htmlFor="state"
            className="field-label2"
            style={{ marginBottom: "2px" }}
          >
            Date of Action
          </InputLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              renderDay={renderDay}
              value={
                selectedDueDate
                  ? formatToUsDateFromUTCNew(selectedDueDate)
                  : null
              }
              open={showDatePicker}
              onOpen={() => setShowDatePicker(true)}
              onClose={() => setShowDatePicker(false)}
              onChange={handleDateChange}
              className="textInput plainLabel"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              InputProps={{
                disableUnderline: true,
                inputProps: {
                  placeholder: "mm/dd/yyyy",
                  style: {
                    color: "#868382",
                    opacity: 1,
                    marginTop: "0",
                    fontFamily: "QuicksandBold",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    padding: "8px 16px",
                  },
                },
              }}
              style={{
                margin: 0,
                backgroundColor: "rgb(239, 233, 231)",
                width: "100%",
              }}
              ToolbarComponent={() => (
                <Link
                  sx={{
                    fontSize: "14px",
                    order: 1,
                    textAlign: "right",
                    padding: "15px",
                    paddingTop: "0",
                  }}
                  onClick={() => {
                    setSelectedDueDate(dueDate);
                    setShowDatePicker(false);
                  }}
                >
                  Clear
                </Link>
              )}
            />
          </MuiPickersUtilsProvider>
        </Box>
      </Box>
    </GeneralModal>
  );
};

export default DueDateModal;
